// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3xb3L","log":"ModalInventoryLogs_log__32aVe","date":"ModalInventoryLogs_date__X5HlH","userName":"ModalInventoryLogs_userName__ZhAWE"};